import type { ReactNode } from "react";

import { Text } from "@/components/ui/text";
import { cn } from "@/components/ui/utils";
import { UserTimestamp, type UserTimestampProps } from "./UserTimestamp";

type DetailItemProps = {
  children: ReactNode;
  title: string;
  condensed?: boolean;
  className?: string;
};

export function DetailItem({
  children,
  title,
  condensed,
  className,
}: DetailItemProps) {
  return (
    <div className={cn("w-full", className)}>
      <Text size="1" muted>
        {title}
      </Text>
      <Text elementType="div" size={condensed ? "1" : "2"}>
        {children}
      </Text>
    </div>
  );
}

export function CommentDetailItem({
  children,
  title,
  ...userTsProps
}: Omit<DetailItemProps, "children"> &
  UserTimestampProps & { children?: string | null }) {
  return (
    <DetailItem title={title}>
      <div className="rounded p-2 bg-muted">
        <pre className="font-sans text-sm whitespace-pre-wrap">
          {children || "-"}
        </pre>
        <UserTimestamp {...userTsProps} />
      </div>
    </DetailItem>
  );
}
